export const hasUnconfirmedEmail = (state) => !!state.entities.users.unconfirmedEmail;

